import { Avatar, Body, Icon } from 'copilot-design-system';

import { getInitials } from 'src/utils/UserUtils';

import { CompanyAutocompleteItem } from './types';

export const SelectCompanyAutocompleteItem = (
  value: Prettify<CompanyAutocompleteItem>,
) => {
  if (value.company) {
    return (
      <div className="flex items-center">
        <Avatar
          src={value.company.fields.avatarImageURL}
          fallbackColor={value.company.fields.fallbackColor}
          text={getInitials(value.company.fields.name)}
          size="sm"
          variant="rounded"
          alt={value.company.fields.name}
        />
        <Body size="sm" className="ml-2">
          {value.company.fields.name}
        </Body>
      </div>
    );
  }

  return (
    <div className="flex items-center">
      <Icon icon="Plus" className="w-3.5 h-3.5" />
      <Body size="sm" className="ml-2">
        Create {value.label}
      </Body>
    </div>
  );
};
